import React, { useState } from 'react';
import './no-access.css';
import AccessDeniedIcon from '../../assets/access-blocked.svg';
import { sendAccessRequest } from '../../api/access_request';
import logger from "#/utils/logger";

export interface NoAccessProps {
  errorCode?: string;
  expirationDate?: string;
  accessRequestStatus?: 'pending' | 'approved' | 'denied' | null;
  accessRequestTime?: string;
}

const NoAccess: React.FC<NoAccessProps> = ({ errorCode, expirationDate, accessRequestStatus, accessRequestTime }) => {
  const [showThankYou, setShowThankYou] = useState(false);
  const [isButtonFading, setIsButtonFading] = useState(false);

  const handleRequestAccess = async () => {
    try {
      setIsButtonFading(true);
      await sendAccessRequest();
      setTimeout(() => {
        setShowThankYou(true);
        setIsButtonFading(false);
      }, 200);
    } catch (error) {
      logger.error('Error requesting access:', error);
      setIsButtonFading(false);
    }
  };

  let supportMessage = "You don't have access to this server.";
  if (errorCode === 'user_not_found') {
    supportMessage = "You don't have access to this server.";
  } else if (errorCode === 'user_access_expired') {
    supportMessage = `${'Your access has expired on ' + expirationDate + '.'}`;
  }

  const renderAccessRequest = () => {
    if (showThankYou) {
      return (
        <p className="access-status fade-in unselectable">
          Thank you for your request. We'll be in contact soon.
        </p>
      );
    }

    if (!accessRequestStatus) {
      return (
        <>
          <p className="unselectable">Or request access:</p>
          <button 
            className={`request-access-button ${isButtonFading ? 'fade-out' : ''}`} 
            onClick={handleRequestAccess}
            disabled={isButtonFading}
          >
            Request Access
          </button>
        </>
      );
    }
    const statusText = accessRequestStatus.charAt(0).toUpperCase() + accessRequestStatus.slice(1);
    return (
      <div className="access-status unselectable">
        <span className="status-label">Access Request Status</span>
        <span className={`status-badge status-${accessRequestStatus}`}>
          {statusText}
        </span>
        <span className="status-time">
          {accessRequestStatus === 'denied' 
            ? "If you believe this is an error, please contact support@spogen.ai"
            : accessRequestTime && `Requested on ${accessRequestTime}`
          }
        </span>
      </div>
    );
  };

  return (
    <div className="no-access-container">
      <div className="no-access-content">
        <div className="icon-container">
          <img src={AccessDeniedIcon} className="access-icon" alt="Access Denied" />
        </div>
        <h1 className="unselectable">Access Denied</h1>
        <p className="unselectable">{supportMessage}</p>
        {!accessRequestStatus && !showThankYou && (
          <p className="unselectable">If you believe this is an error, please contact support@spogen.ai</p>
        )}
        {renderAccessRequest()}
      </div>
    </div>
  );
};

export default NoAccess;
